<template>
  <div>
    <div class="billing-info">
      <p class="billing-contact-para">Billing Contact’s Information</p>
      <!-- first and lastname -->
      <div class="row content">
        <div class="col-md-6 col-sm-6">
          <div class="form-group">
            <label for="" class="header-label"
              >First Name<span class="required_astric" v-if="!user_data.first_name">*</span></label
            >
            <input
              class="form-control"
              :class="$v.user_data.first_name.$error ? 'invalid-border' : ''"
              v-model.trim="$v.user_data.first_name.$model"
              type="text"
              placeholder="First Name"
              maxlength="65"
            />
            <div v-if="$v.user_data.first_name.$error">
              <div class="custom-error-class pt-8" v-if="!$v.user_data.first_name.required">
                Complete required field
              </div>
              <div class="custom-error-class pt-8" v-else-if="!$v.user_data.first_name.minLength">
                Minimum 2 characters required.
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6">
          <div class="form-group">
            <label for="" class="header-label"
              >Last Name<span class="required_astric" v-if="!user_data.last_name">*</span></label
            >
            <input
              class="form-control"
              :class="$v.user_data.last_name.$error ? 'invalid-border' : ''"
              type="text"
              placeholder="Last Name"
              v-model.trim="$v.user_data.last_name.$model"
              maxlength="65"
            />
            <div v-if="$v.user_data.last_name.$error">
              <div class="custom-error-class pt-8" v-if="!$v.user_data.last_name.required">
                Complete required field
              </div>
              <div class="custom-error-class pt-8" v-else-if="!$v.user_data.last_name.minLength">
                Minimum 2 characters required.
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- email nd phone -->
      <div class="row content">
        <div class="col-md-6 col-sm-6">
          <div class="form-group">
            <label for="" class="header-label"
              >Email address<span class="required_astric" v-if="!user_data.email_address"
                >*</span
              ></label
            >
            <input
              class="form-control"
              :class="$v.user_data.email_address.$error ? 'invalid-border' : ''"
              type="text"
              placeholder="Email"
              v-model.trim="$v.user_data.email_address.$model"
              maxlength="65"
            />
            <div v-if="$v.user_data.email_address.$error">
              <div class="custom-error-class pt-8" v-if="!$v.user_data.email_address.required">
                Complete required field
              </div>
              <div
                class="custom-error-class pt-8"
                v-else-if="!$v.user_data.email_address.isValidMail"
              >
                Invalid email format. Valid entries include: someone@example.com.
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6">
          <div class="form-group">
            <label for="" class="header-label"
              >Phone number<span class="required_astric" v-if="!user_data.phone_number"
                >*</span
              ></label
            >
            <input
              class="form-control"
              :class="$v.user_data.phone_number.$error ? 'invalid-border' : ''"
              type="text"
              size="15"
              maxlength="30"
              placeholder="Phone number"
              v-model.trim="$v.user_data.phone_number.$model"
            />
            <div v-if="$v.user_data.phone_number.$error">
              <div class="custom-error-class pt-8" v-if="!$v.user_data.phone_number.required">
                Complete required field
              </div>
              <div class="custom-error-class pt-8" v-if="!$v.user_data.phone_number.isNumber">
                Please enter valid phone number
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <hr class="billing-info-line" />
      </div>

      <!-- Address -->
      <div class="row content">
        <div class="col-md-12 col-sm-12">
          <div class="form-group">
            <label for="" class="header-label"
              >Address<span class="required_astric" v-if="!user_data.address">*</span></label
            >
            <input
              class="form-control"
              :class="$v.user_data.address.$error ? 'invalid-border' : ''"
              type="text"
              size="60"
              placeholder="Street Address"
              v-model.trim="$v.user_data.address.$model"
            />
            <div v-if="$v.user_data.address.$error">
              <div class="custom-error-class pt-8" v-if="!$v.user_data.address.required">
                Complete required field
              </div>
              <div class="custom-error-class pt-8" v-if="!$v.user_data.address.isAllowedCharacters">
                {{ specialCharacterErrMsg }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- city, state nd zip -->
      <div class="row content">
        <div class="col-md-6 col-sm-6">
          <div class="form-group">
            <label for="" class="header-label"
              >City<span class="required_astric" v-if="!user_data.city">*</span></label
            >
            <input
              class="form-control"
              :class="$v.user_data.city.$error ? 'invalid-border' : ''"
              type="text"
              size="60"
              maxlength="50"
              placeholder="City"
              v-model.trim="$v.user_data.city.$model"
            />
            <div v-if="$v.user_data.city.$error">
              <div class="custom-error-class pt-8" v-if="!$v.user_data.city.required">
                Complete required field
              </div>
              <div class="custom-error-class pt-8" v-if="!$v.user_data.city.minLength">
                Minimum 3 characters required.
              </div>
              <div
                class="custom-error-class pt-8"
                v-else-if="!$v.user_data.city.isAllowedCharacters"
              >
                {{ specialCharacterErrMsg }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2 col-sm-2">
          <div class="form-group">
            <label for="" class="header-label"
              >State<span class="required_astric" v-if="!user_data.state">*</span></label
            >
            <input
              class="form-control"
              :class="$v.user_data.state.$error ? 'invalid-border' : ''"
              type="text"
              size="60"
              maxlength="50"
              placeholder="State"
              v-model.trim="$v.user_data.state.$model"
            />
            <div v-if="$v.user_data.state.$error">
              <div class="custom-error-class pt-8 pb-20" v-if="!$v.user_data.state.required">
                Complete required field
              </div>
              <div
                class="custom-error-class pt-8 pb-20"
                v-if="!$v.user_data.state.isAllowedCharacters"
              >
                {{ specialCharacterErrMsg }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-4">
          <div class="form-group">
            <label for="" class="header-label"
              >Zip Code<span class="required_astric" v-if="!user_data.zipcode">*</span></label
            >
            <input
              class="form-control"
              :class="$v.user_data.zipcode.$error ? 'invalid-border' : ''"
              type="text"
              maxlength="15"
              placeholder="Zip / Postal code"
              v-model.trim="$v.user_data.zipcode.$model"
            />
            <div v-if="$v.user_data.zipcode.$error">
              <div class="custom-error-class pt-8" v-if="!$v.user_data.zipcode.required">
                Complete required field
              </div>
              <div class="custom-error-class pt-8" v-if="!$v.user_data.zipcode.minLength">
                Minimum 2 characters required.
              </div>
              <div
                class="custom-error-class pt-8"
                v-else-if="!$v.user_data.zipcode.isPostalCode && user_data.zipcode"
              >
                Valid Zip/Postal Code Required
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- country -->
      <div class="row content">
        <div class="col-md-6 col-sm-6">
          <div class="form-group">
            <label for="" class="header-label"
              >Country<span class="required_astric" v-if="!user_data.country">*</span></label
            >
            <multiselect
              class="multiselect-single-dropdown"
              :class="{
                'invalid-border': $v.user_data.country.$error,
                'un-selected': !$v.user_data.country.$model
              }"
              :allow-empty="false"
              placeholder="Select a country"
              v-model.trim="$v.user_data.country.$model"
              :show-labels="false"
              :options="countriesList.map((type) => type.country_name)"
              :custom-label="
                (opt) => countriesList.find((x) => x.country_name === opt).country_name
              "
            ></multiselect>

            <div
              class="custom-error-class pt-40"
              v-if="!$v.user_data.country.required && $v.user_data.country.$error"
            >
              Complete required field
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6" v-if="purchaseOrder">
          <div class="form-group">
            <label for="" class="header-label">
              <!-- <span class="checkbox">
                <label>
                  <input
                    type="checkbox"
                    v-model="isPurchaseOrder"
                  />
                  <span class="cr">
                  </span>
                </label>
              </span> -->
              Purchase Order
              <label class="switch">
                <input type="checkbox" v-model="isPurchaseOrder" />
                <span class="slider round"></span>
              </label>
            </label>
            <input
              v-if="isPurchaseOrder"
              :disabled="!isPurchaseOrder"
              class="form-control"
              :class="$v.user_data.purchase_order.$error ? 'invalid-border' : ''"
              type="text"
              placeholder="Purchase Order"
              v-model.trim="$v.user_data.purchase_order.$model"
            />
            <div v-if="isPurchaseOrder && $v.user_data.purchase_order.$error">
              <div class="custom-error-class pt-8" v-if="!$v.user_data.purchase_order.required">
                Complete selected field
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'; //eslint-disable-line
import { validateData, purchaseOrderObject } from './BillingInfoValidator';
import { getAllCountries } from '../../../apis/countriesList';

export default {
  components: {},
  props: ['billingData', 'purchaseOrder', 'current_slide'],
  data() {
    return {
      user_data: {
        first_name: '',
        last_name: '',
        email_address: '',
        country: '',
        phone_number: '',
        address: '',
        city: '',
        state: '',
        zipcode: '',
        purchase_order: ''
      },
      countriesList: [],
      validateFormSubmit: false,
      specialCharacterErrMsg: 'The following characters are not allowed: * ? < > ! # @ $ “ % ^',
      isPurchaseOrder: false
    };
  },
  validations() {
    if (this.isPurchaseOrder) {
      return { user_data: purchaseOrderObject };
    }
    return { user_data: validateData };
  },
  watch: {
    billingData() {
      this.initializeUserData();
      this.$emit('saveBillingInfo', { apiType: 'no', billingInfo: this.user_data });
    },
    isPurchaseOrder() {
      this.$set(this.user_data, 'purchase_order', '');
    },
    current_slide() {
      if (this.current_slide === 3) {
        this.validateUserData();
        this.validateFormSubmit = this.validateFormSubmit ? false : this.validateFormSubmit;
      }
    },
    user_data: {
      handler() {
        if (this.$v.$anyDirty) {
          this.validateFormSubmit = true;
        }
      },
      deep: true
    }
  },
  async created() {
    await this.getCountryList();
    this.initializeUserData();
  },
  methods: {
    initializeUserData() {
      if (this.billingData && Object.keys(this.billingData).length !== 0) {
        this.user_data.first_name = this.billingData.first_name;
        this.user_data.last_name = this.billingData.last_name;
        this.user_data.email_address = this.billingData.email_address;
        this.user_data.country = this.billingData.country;
        this.user_data.phone_number = this.billingData.phone_number;
        this.user_data.address = this.billingData.address;
        this.user_data.city = this.billingData.city;
        this.user_data.state = this.billingData.state;
        this.user_data.zipcode = this.billingData.zipcode;
        this.user_data.purchase_order = '';
      }
    },
    validateUserData() {
      if (!this.billingData || Object.keys(this.billingData).length === 0) {
        this.validateFormEmit('post');
      } else {
        this.validateFormEmit('put');
      }
    },
    validateFormEmit(apiType) {
      if (this.validateFormSubmit) {
        this.emitFormValues(apiType);
      }
    },
    emitFormValues(apiType) {
      if (this.$v.$dirty && !this.$v.$invalid) {
        const formData = this.user_data;
        if (!this.purchaseOrder) {
          delete formData.purchase_order;
        }
        this.$emit('saveBillingInfo', { apiType, billingInfo: formData });
      }
    },
    async getCountryList() {
      if (localStorage.getItem('countryList')) {
        this.countriesList = JSON.parse(localStorage.getItem('countryList'));
      } else {
        this.countriesList = await getAllCountries();
      }
    }
  }
};
</script>

<style scoped>
.billing-info {
  border: 1px solid #d3d6d9;
  box-sizing: border-box;
  border-radius: 10px;
  margin-top: 16px;
  margin-bottom: 8px;
  padding: 10px 28px;
}
.billing-info-line {
  margin-top: 24px;
  margin-bottom: 22px;
}
p.billing-contact-para {
  padding-bottom: 12px;
  font-size: 24px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.7);
}
.required_astric {
  font-size: 12px;
  color: red;
  margin-left: 2px;
  vertical-align: top;
}
.switch {
  margin-left: 10px;
}
</style>
